import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";

@Component({
  selector: 'page-all-std-progress-report',
  templateUrl: 'all-std-progress-report.html',
})
export class AllStdProgressReportPage {

  AllDefaultData: any;
  AllData:any;

  School = 'All';
  SchoolData = {};

  hide = 0;

  constructor(public navCtrl: NavController,
              public service: ServiceProvider,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController,
              public platform: Platform,
              public navParams: NavParams) {

    this.platform.ready().then(() => {

      this.SchoolData = {
        "All": 0,
        "GWW": 2,
        "GWE": 3,
        "GEIS": 1
      };
      this.loadvalues(this.SchoolData[this.School]);

    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AllStdProgressReportPage');
  }

  active_tab(tab) {
    this.hide = 0;
    console.log(tab);
    this.School = tab;
    this.loadvalues(this.SchoolData[this.School]);
  }

  loadvalues(schooldID) {
    this.hide = 0;

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();
    this.AllData = [];
    this.AllDefaultData = [];
    this.service.httpcall('app_web_service/get_all_std_progress_report?SchoolId='+schooldID).subscribe(data => {

      this.AllData = data;
      this.AllDefaultData = data['Data'];
      this.hide = 1;
      console.log('AllSorceData',this.AllData);
      loading.dismiss();
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues(this.SchoolData[this.School]);


    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/all-std-progress-report/all-std-progress-report.ts